import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import {
    passwordOrAKVtoSecretBase,
    secretBaseToPasswordOrAKV
} from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { GoogleCloudStorageLinkedService } from 'app/model/linkedservice/google-cloud-storage.linkedservice';

export const adapts = {
    name: '*',
    properties: {
        description: '*',
        type: '*',
        connectVia: '*',
        typeProperties: {
            serviceUrl: '*',
            accessKeyId: '*',
            secretAccessKey: 'secret',
            encryptedCredential: '*'
        }
    }
};

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GoogleCloudStorageLinkedService),
    asynchronous: true,
    adapts
})
export class GoogleCloudStorageLinkedServiceAdapter extends LinkedServiceAdapter<GoogleCloudStorageLinkedService> {
    protected modelConstructor(): new () => GoogleCloudStorageLinkedService {
        return GoogleCloudStorageLinkedService;
    }

    protected model(): IModel {
        return GoogleCloudStorageLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(
        linkedService: GoogleCloudStorageLinkedService,
        linkedServiceResource: Model.LinkedServiceResource
    ): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.GoogleCloudStorageLinkedService;

        properties.type = this.model().name;
        properties.typeProperties = {
            serviceUrl: linkedService.serviceUrl,
            accessKeyId: linkedService.accessKeyId,
            secretAccessKey: passwordOrAKVtoSecretBase(linkedService.secretAccessKey, this.context)
        };
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(
        linkedServiceResource: Model.LinkedServiceResource,
        linkedService: GoogleCloudStorageLinkedService
    ): Promise<GoogleCloudStorageLinkedService> {
        const properties = linkedServiceResource.properties as Model.GoogleCloudStorageLinkedService;
        // clear model default value
        linkedService.serviceUrl =
            properties.typeProperties.serviceUrl != null ? properties.typeProperties.serviceUrl : undefined;
        linkedService.accessKeyId = properties.typeProperties.accessKeyId;
        linkedService.secretAccessKey = secretBaseToPasswordOrAKV(
            properties.typeProperties.secretAccessKey as Model.SecretBase,
            true,
            this.context
        );
        return linkedService;
    }
}
